import * as React from "react";
import { connect } from "react-redux";
import Label from "../../components/Label";
import ErrorMessage from "../../components/ErrorMessage";
import { Typeahead } from "react-bootstrap-typeahead";
import "../../../assets/sass/widgets/typeAhead.scss";
import IProps from "./IProps";
import { bindActionCreators } from "redux";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import { validationCheck } from "../../utils/validation";
import { getDataFromStore } from "../../utils/utils";

/**
 * @ignore
 */
interface IState {
    selectedValue?: any;
    error: any;
}
/**
 * @class PropertyManagerTypeAhead
 * @category Widgets
 * @description This component renders the input box for street address and uses react-places-autocomplete library to display the suggestion list to the user based on the input , this handles assigning the values to the state, city, zipcode  once the user selects one of the lists from suggestion
 */
class PropertyManagerTypeAhead extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            selectedValue: [{ label: "" }],
            error: { error: false, errorMessage: [] },
        };
        this.onBlurCheck = this.onBlurCheck.bind(this);
    }
    componentDidMount() {
        if (this.props.value) this.handleChange(this.props.value);
        if (!this.props.propertyManagerList.length) this.props.dynamicFormActions.getPropertyManagerList();
    }
    componentDidUpdate(prevProps, nextProps) {
        const { onChange, schema, value: propValue, warrantyData } = this.props;
        if (prevProps.schema.const.family !== this.props.schema.const.family) {
            this.setState({
                error: { error: false, errorMessage: [] },
            });
        }
        if ((!prevProps.warrantyData || Object.keys(prevProps.warrantyData).length === 0) && warrantyData) {
            if (propValue) {
                this.handleChange(propValue);
            }
        } else {
            if (schema.const && schema.const.dataSource && schema.const.dataSource.length > 0) {
                const value = getDataFromStore(schema.const.dataSource, this.props, this.state.selectedValue);
                if (value != undefined) {
                    this.setState({ selectedValue: value }, () => {
                        onChange(value);
                    });
                }
            }
        }
    }

    handleSelect = (value) => {
        if (value && value.length > 0) {
            this.props.onChange(value[0].label);
            this.setState({
                selectedValue: value,
            });
        }
    };

    /**
     *
     */
    handleChange = (value) => {
        // if (value && value.length > 0) {
            this.props.onChange(value);
            this.setState({
                selectedValue: [{ label: value }],
            });
        // }
        // this.props.onChange(value);
    };

    /**
     * @function onBlurCheck
     * @param event
     * @description
     *      1: Validates the targeted value with that comming in from the errorSchema
     * @ignore
     */
    onBlurCheck(event) {
        const { family } = this.props.schema.const;
        const { errorSchema } = this.props;
        const id = this.props.id.split("_");
        const fieldName = this.props.id.split("_")[id.length - 1];
        const validationError = validationCheck(event.target.value, fieldName, family, errorSchema);
        if (validationError && validationError.error) {
            this.setState({
                error: validationCheck(event.target.value, fieldName, family, errorSchema),
            });
        } else {
            this.setState({ error: { error: false, errorMessage: [] } });
            if(event.target.value && event.target.value.length > 0) {
                this.fieldClicked()
            }
        }
    }

    fieldClicked = () => {
        const { removeFieldIdFromStore } = this.props.dynamicFormActions;
        removeFieldIdFromStore(this.props.id);
    };

    render() {
        const { schema, id, errorDetails, propertyManagerList } = this.props;
        const { selectedValue, error } = this.state;
        return (
            <div onBlur={this.onBlurCheck}>
                <Label schema={schema} />
                <Typeahead
                    onChange={this.handleSelect}
                    onInputChange={this.handleChange}
                    options={propertyManagerList}
                    minLength={3}
                    id={`${id}-autosearch`}
                    placeholder="Search company list"
                    className={
                        (error && error.error && error.errorMessage.length > 0) ||
                            (this.props.errorDetails[id] && this.props.errorDetails[id].length > 0)
                            ? "gaf-autosuggest error-boundry"
                            : "gaf-autosuggest inputbox-rectangle"
                    }
                    selected={selectedValue}
                    renderInput={({ inputRef, referenceElementRef, ...inputProps }) => (
                        <input
                            {...inputProps}
                            id={id}
                            className="gaf-inputbox"
                            ref={(input) => {
                                // Be sure to correctly handle these refs. In many cases, both can simply receive
                                // the underlying input node, but `referenceElementRef can receive a wrapper node if
                                // your custom input is more complex (See TypeaheadInputMulti for an example).
                                inputRef(input);
                                referenceElementRef(input);
                            }}
                        />
                    )}
                />
                <ErrorMessage errorDetails={errorDetails} errorState={error} propId={id} />
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        errorDetails: state.dynamicFormInfo.errorDetails || {},
        propertyManagerList: state.dynamicFormInfo.propertyManagerList || [],
        warrantyData: state.dynamicFormInfo.layoutResponse.WarrantyData,
    };
};

export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
    };
}

/**
 *
 */
export default connect(mapStateToProps, mapDispatchToProps)(PropertyManagerTypeAhead);
